module.exports = __webpack_public_path__ + "img/BINDI 2 BW.81f0d54.svg";